module.exports = __webpack_public_path__ + "static/media/IMG_3624.f4c6ab96.jpg";